import * as types from '../constants/officeRunnerConstants'

const stateInfo = (state = null, action) => {
  switch (action.type) {
    case types.RECEIVE_STATE_INFO:
      return action.stateInfo
    default:
      return state
  }
}

export default stateInfo



// WEBPACK FOOTER //
// ./src/reducers/stateInfoReducer.js